import { type ComponentProps } from 'react';

import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';

type CheckboxWithLabelProps = ComponentProps<typeof Checkbox> & {
  label: string;
};

export function CheckboxWithLabel({ label, ...props }: CheckboxWithLabelProps) {
  return (
    <div className="flex w-full items-center gap-3">
      <Checkbox className="pointer-events-none" {...props} />
      <Label htmlFor={props.id} className="pointer-events-none w-full text-sm font-normal">
        {label}
      </Label>
    </div>
  );
}
